import Modal from "@/components/common/modal";
import { Button, Icon } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

interface Props {
  isOpen: boolean;
  onClose?: () => void;
  onAccept: () => void;
  title: string;
  description: string;
  cancelText?: string;
  acceptText: string;
  acceptVariant?:
    | "default"
    | "secondary"
    | "danger-secondary"
    | "tertiary"
    | "ghost"
    | "quiet"
    | "ghost-blue"
    | "danger-primary"
    | "danger-tertiary"
    | "alpha-neutral";
  isLoading?: boolean;
  modalContentClassName?: string;
  hideCancelButton?: boolean;
}

const ConfirmationModalBase = ({
  isOpen,
  onClose,
  onAccept,
  title,
  description,
  cancelText = "Cancelar",
  acceptText,
  acceptVariant = "default",
  isLoading = false,
  modalContentClassName = "max-w-[520px] w-full gap-7",
  hideCancelButton = false,
}: Props) => {
  return (
    <Modal
      data-testid="confirmation-modal-base"
      isOpen={isOpen}
      onClose={() => onClose?.()}
      title={title}
      description={description}
      modalContentClassName={modalContentClassName}
    >
      <div
        className={cn(
          "w-full grid gap-3 pt-1",
          hideCancelButton
            ? "grid-cols-1 tablet:grid-cols-1"
            : "grid-cols-2 tablet:grid-cols-2",
        )}
      >
        {/* Botón de aceptar primero en el DOM para recibir el foco automáticamente */}
        <Button
          data-testid="accept-button"
          size="lg"
          variant={acceptVariant}
          className={cn(
            "w-full rounded-lg cursor-pointer",
            !hideCancelButton && "order-2",
          )}
          type="submit"
          disabled={isLoading}
          onClick={onAccept}
        >
          {acceptText}
          {isLoading && (
            <Icon
              data-testid="loading-indicator"
              type="far"
              name="spinner-third"
              className={cn("text-current", "animate-spin")}
            />
          )}
        </Button>
        {!hideCancelButton && (
          <Button
            data-testid="cancel-button"
            size="lg"
            type="button"
            className="w-full rounded-lg cursor-pointer order-1"
            variant="tertiary"
            onClick={onClose}
          >
            {cancelText}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModalBase;
